'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
require('styled-components');
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
require('../browser-05a2bba8.js');
require('react-dom');
require('../_commonjsHelpers-3fc1f64e.js');
require('../_react_commonjs-external-30e5c7b3.js');
require('../_prop-types_commonjs-external-c51b2bd5.js');
require('../style-222d2b0f.js');
require('lodash/camelCase');
require('lodash/upperFirst');
require('../icon.js');
require('../hr.js');
require('../typography/span.js');
require('../styles-ab893f86.js');
require('../index-4b81da60.js');
require('../invariant-8c441586.js');
require('../react-lifecycles-compat.es-59afd828.js');
require('../_react-dom_commonjs-external-3c49a59a.js');
require('../button/transparent.js');
var container = require('./container.js');
require('../typography/s18.js');
var item = require('./item.js');

function withFormikArrayField(FormikArrayField) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    _babelHelpers.inherits(ArrayFieldGroup, _React$Component);

    function ArrayFieldGroup(props) {
      _babelHelpers.classCallCheck(this, ArrayFieldGroup);

      var _this = _babelHelpers.possibleConstructorReturn(this, (ArrayFieldGroup.__proto__ || Object.getPrototypeOf(ArrayFieldGroup)).call(this, props));

      _this.state = {
        dropdownToggle: false
      };
      return _this;
    }

    _babelHelpers.createClass(ArrayFieldGroup, [{
      key: "getValuesToRender",
      value: function getValuesToRender() {
        var _props = this.props,
            values = _props.values,
            fieldGroupName = _props.fieldGroupName,
            minLength = _props.minLength,
            itemDefaultValue = _props.itemDefaultValue;

        var arrayValue = values[fieldGroupName];
        if (Array.isArray(arrayValue)) {
          var a = 0;
          while (arrayValue.length < minLength && a < 100) {
            // prevent while loop too long
            a += 1;
            arrayValue.push(itemDefaultValue);
          }
          return arrayValue;
        }
        return [];
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _props2 = this.props,
            addBtnId = _props2.addBtnId,
            removeBtnId = _props2.removeBtnId,
            addButtonText = _props2.addButtonText,
            itemDefaultValue = _props2.itemDefaultValue,
            values = _props2.values,
            fieldGroupName = _props2.fieldGroupName,
            removeButtonText = _props2.removeButtonText,
            renderFields = _props2.renderFields,
            title = _props2.title,
            maxLength = _props2.maxLength,
            minLength = _props2.minLength,
            useCustomComponent = _props2.useCustomComponent,
            padding = _props2.padding,
            margin = _props2.margin,
            _props2$dropdownOptio = _props2.dropdownOptions,
            dropdownOptions = _props2$dropdownOptio === undefined ? [] : _props2$dropdownOptio;
        var dropdownToggle = this.state.dropdownToggle;

        var propsToBePassed = function propsToBePassed(index, arrayHelpers) {
          return {
            removeBtnId: removeBtnId + index.toString(),
            key: title(index),
            title: title(index),
            removeButtonText: removeButtonText,
            onClickRemoveButton: function onClickRemoveButton() {
              return arrayHelpers.remove(index);
            },
            removable: minLength ? values[fieldGroupName].length > minLength : true
          };
        };
        var setDropdownToggle = function setDropdownToggle() {
          _this2.setState({ dropdownToggle: !dropdownToggle });
        };
        var handleClickAddButton = function handleClickAddButton(arrayHelpers) {
          return function () {
            arrayHelpers.push(_babelHelpers._extends({}, itemDefaultValue));
          };
        };
        var handleClickDropdown = function handleClickDropdown(arrayHelpers) {
          return function (options) {
            return function () {
              arrayHelpers.push(_babelHelpers._extends({}, itemDefaultValue, options));
              setDropdownToggle();
            };
          };
        };
        return React__default.createElement(FormikArrayField, {
          name: fieldGroupName,
          render: function render(arrayHelpers) {
            return React__default.createElement(
              container,
              {
                padding: padding,
                margin: margin,
                addBtnId: addBtnId,
                addButtonText: addButtonText,
                onToggleDropdown: setDropdownToggle,
                onClickAddButton: handleClickAddButton(arrayHelpers),
                handleClickDropdown: handleClickDropdown(arrayHelpers),
                dropdownOptions: dropdownOptions,
                dropdownToggle: dropdownToggle,
                addable: maxLength ? values[fieldGroupName].length < maxLength : true },
              _this2.getValuesToRender().map(function (item$1, index) {
                return useCustomComponent ? renderFields(item$1, index, propsToBePassed(index, arrayHelpers)) : React__default.createElement(
                  item.default,
                  propsToBePassed(index, arrayHelpers),
                  renderFields(item$1, index)
                );
              })
            );
          }
        });
      }
    }]);
    return ArrayFieldGroup;
  }(React__default.Component), _class.propTypes = {
    /** Array field add new group button ID */
    addBtnId: PropTypes$1.string.isRequired,
    /** Array field remove group button ID */
    removeBtnId: PropTypes$1.string.isRequired,
    /** function that receive index and return string to show above each field group */
    title: PropTypes$1.func,
    /** text to display on remove field group button */
    removeButtonText: PropTypes$1.string,
    /** text to display on add field group button */
    addButtonText: PropTypes$1.string,
    /** name of array in formik values */
    fieldGroupName: PropTypes$1.string,
    /** field and initial in each group */
    itemDefaultValue: PropTypes$1.object,
    /** values from formik */
    values: PropTypes$1.object,
    /** custom margin */
    margin: PropTypes$1.string,
    /** custom padding */
    padding: PropTypes$1.string,
    /** field group component to render *need to assign value,error,with formik data correctly */
    renderFields: PropTypes$1.func,
    maxLength: PropTypes$1.number,
    minLength: PropTypes$1.number
  }, _temp;
}

module.exports = withFormikArrayField;
//# sourceMappingURL=index.js.map
